<div class="cuerpo">
    <div class="info">
        <p >{{nombre}}</p>
        <button (click)="trasnferir()">ATENDER</button>
    </div>

</div>